import React from "react";

import "./404.styles.scss";

const PageNotFound = () => {
  return <div className="fallback container"> 404 page not found</div>;
};

export default PageNotFound;
